//@flow
import Constants   from   "../constants";
import Dispatcher  from '../dispatcher';

import type { HelloBarData } from '../Stores/HelloBar/helloBarStoreClass';

export default {
  setHelloBarText(text:string) {
    Dispatcher.dispatchAction(Constants.SET_HELLOBAR_TEXT, { text });
  },

  setAdditionalHelloBarText(additionalText:string) {
    Dispatcher.dispatchAction(Constants.SET_ADDITIONAL_HELLOBAR_TEXT, { additionalText });
  },

  resetHelloBarText() {
    Dispatcher.dispatchAction(Constants.RESET_HELLOBAR_TEXT);
  },

  setData(data:HelloBarData){
    Dispatcher.dispatchAction(Constants.SET_HELLOBAR_DATA, data);
  },
};
